module.exports = __webpack_public_path__ + "img/horcrux-rowena-ravenclaw.407d8d97.png";